import type { IconProps } from '../types';

const User = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M15.963 4a5.39 5.39 0 0 0-2.98.901 5.314 5.314 0 0 0-1.97 2.415 5.36 5.36 0 0 0-.313 3.1 5.402 5.402 0 0 0 1.466 2.75 5.354 5.354 0 0 0 2.752 1.466 5.458 5.458 0 0 0 3.1-.3 5.362 5.362 0 0 0 3.316-4.962A5.375 5.375 0 0 0 15.962 4zm0 8.722a3.355 3.355 0 0 1-3.1-2.066 3.478 3.478 0 0 1-.192-1.947c.132-.648.456-1.249.925-1.718a3.378 3.378 0 0 1 1.718-.913 3.334 3.334 0 0 1 1.934.193 3.385 3.385 0 0 1 1.514 1.237c.373.553.565 1.201.565 1.862 0 .89-.349 1.742-.985 2.367a3.355 3.355 0 0 1-2.38.985zM6 22.786V27h19.933v-4.214c0-3.65-4.383-6.52-9.973-6.52-5.577 0-9.96 2.87-9.96 6.52zm17.716 0v1.922H8.218v-1.922c0-1.99 3.188-4.213 7.755-4.213s7.743 2.223 7.743 4.213z" />
  </svg>
);

export default User;
